import { render, staticRenderFns } from "./email-template.vue?vue&type=template&id=29b03299&scoped=true"
import script from "./email-template.vue?vue&type=script&lang=ts"
export * from "./email-template.vue?vue&type=script&lang=ts"
import style0 from "./email-template.vue?vue&type=style&index=0&id=29b03299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b03299",
  null
  
)

export default component.exports